import { useState, useEffect } from 'react';
import IntegrationJson from '../assets/integrations/integrations.json';
import { JSONData } from '../models/about-bonk.model';

/**
 * Counts total “integrations.data.length” across all items in the JSON.
 */
export function useIntegrationCount(): number {
    const [count, setCount] = useState(0);

    useEffect(() => {
        try {
            const data = (IntegrationJson as JSONData).data;
            if (!Array.isArray(data)) {
                setCount(0);
                return;
            }
            const total = data.reduce((acc, item) => {
                const ints = item.attributes.integrations?.data;
                return acc + (Array.isArray(ints) ? ints.length : 0);
            }, 0);
            setCount(total);
        } catch {
            setCount(0);
        }
    }, []);

    return count;
}
